import { AppState } from '../state/app.state';

export const getLinkQueueState = (state: AppState) => state.linkQueue;

export const getRouterState = (state: AppState) => state.router;

export const getSharedState = (state: AppState) => state.shared;